import PropTypes from 'prop-types'

import Button from '../../../Theme/Button'
import FAIcon from '../../../Theme/FAIcon'
import { FA_ICONS } from '../../../Theme/font-awesome-icon-constants'

const ButtonFollow = ({ text = 'Follow', iconRight = false, ...rest }) => (
  <Button
    variant="contained"
    color="secondary"
    sx={{ gap: '16px' }}
    {...rest}
  >
    {iconRight && !!text && text}
    <FAIcon
      iconFontSize={16}
      iconClassName={FA_ICONS.USER_PLUS}
    />
    {!iconRight && !!text && text}
  </Button>
)

ButtonFollow.propTypes = {
  text: PropTypes.string,
  iconRight: PropTypes.bool,
}

export default ButtonFollow
